export var listSizesConfig = {
  xxxl: {
    pb: 24
  },
  xxl: {
    pb: 16
  },
  xl: {
    pb: 12
  },
  l: {
    pb: 9
  },
  m: {
    pb: 8
  },
  s: {
    pb: 7
  },
  xs: {
    pb: 6
  }
};